import { IBlogCategoryDto, TBlogCard } from '@blog/types/blog';

export const mapCategoriestoName = (postCategories: TBlogCard['categories'], categoryMap: IBlogCategoryDto[]) => {
    return categoryMap.filter((cat) => postCategories.includes(cat.id)).map((cat) => cat.name);
};

export const sortCategories = (activeCategory: number, categoryMap: IBlogCategoryDto[]) => {
    const activeCategoryPosition = categoryMap?.findIndex((cat) => cat.id === activeCategory);
    if (activeCategoryPosition && activeCategoryPosition > 0) {
        const beforeCategory = categoryMap?.slice(0, activeCategoryPosition);
        const afterCategory = categoryMap?.slice(activeCategoryPosition + 1);
        const sorted = [categoryMap[activeCategoryPosition], ...beforeCategory, ...afterCategory];
        return sorted;
    }
    return categoryMap;
};

export const getBlogSlug = (value: string) => {
    const pathname = value.startsWith('http') ? new URL(value).pathname : value;
    return pathname.split('/').filter(Boolean).pop() ?? '';
};
